import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ImportFilesButton = lazy(() => import('./ImportFilesButton'))

class ImportFilesButtonComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['prop-text', 'prop-disabled']
  }

  override render() {
    const text = this.prop('prop-text')
    const disabled = this.prop('prop-disabled')

    return (
      <AppProviders>
        <ImportFilesButton text={text} disabled={disabled === 'true'} />
      </AppProviders>
    )
  }
}

customElements.define('import-files-button', ImportFilesButtonComponent)
